import React, { createContext } from 'react';
import { auth, generateUserDocument } from '../config/firebase-config';
import { useState, useEffect } from 'react';
//import {Redirect} from 'react-router-dom';


export const UserContext = createContext({ user: null, initializing: true });


 const UserProvider = ( {children} ) => {


     const [user, setUser] = useState(null);
     // Distinguishes "still restoring the session" from "signed out". Without this,
     // PrivateRoute can't tell the two apart on a page refresh and would bounce
     // signed-in users to the sign in screen before Firebase has resolved auth.
     const [initializing, setInitializing] = useState(true);

     useEffect (() => {
        const unsubscribe = auth.onAuthStateChanged(async userAuth => {
            try {
              const user = await generateUserDocument(userAuth);
              setUser(user);
            }
            catch (error) {
              console.error("Error resolving signed in user", error);
              setUser(undefined);
            }
            finally {
              setInitializing(false);
            }
          });

        return () => unsubscribe();

     }, []);


    return (
      <UserContext.Provider value={{user, setUser, initializing}}>

        {children}

      </UserContext.Provider>
    );
  
}
export default UserProvider;